import * as React from 'react';
import theme from '@clad-ui/theme';
import { cx } from '../../utils';
import { Loading } from '../../icons';
import buttonClass from './Button.styles';
const { sizes } = theme;
const variantResolver = (variant, color) => {
    if (variant === 'default') {
        // DEFAULT
        return `default d-${color}`;
    }
    else if (variant === 'outline') {
        // OUTLINE
        return `outline o-${color}`;
    }
    else if (variant === 'tonal') {
        // TONAL
        return `tonal t-${color}`;
    }
    else {
        // SOLID
        return color;
    }
};
/**
 * Renders a standard button element.
 *
 * `✅ Stable`
 */
const Button = React.forwardRef(({ as = 'button', children, color = 'primary', disabled = false, extraClasses = '', icon = false, onClick, radius = 'normal', size = 'medium', stretch = false, variant = 'solid', weight = 'bold', isLoading = false, width, ...props }, ref) => {
    var _a, _b, _c;
    let iconClass = '';
    if (icon) {
        // square/circle icon buttons
        iconClass = 'icon';
    }
    else if (Array.isArray(children)) {
        // if icon is used with text for label
        // detect icon position and set its margin properly
        iconClass = ((_c = (_b = (_a = children === null || children === void 0 ? void 0 : children[1]) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.displayName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes('svg'))
            ? 'i-right'
            : 'i-left';
    }
    else if (isLoading && children) {
        // if loading icon is used with label
        iconClass = 'i-left';
    }
    // prettier-ignore
    const className = cx(buttonClass, variantResolver(variant, color), `r-${radius}`, size, `w-${weight}`, iconClass, stretch && 'stretch', disabled && 'disabled', isLoading && 'loading', extraClasses);
    const attrs = {
        ref,
        className,
        disabled: disabled && true,
        onClick: onClick && !disabled && onClick,
        style: {
            width: width && `${sizes[width]}`,
        },
        'data-clad': 'Button',
        ...props,
    };
    return React.createElement(as, attrs, isLoading && React.createElement(Loading, { className: 'loading-icon' }), children);
});
export default Button;
